import { useMatch } from 'react-router-dom';

import { ecommerceRoutes } from '../components/pages/EcommerceRoutes';
import { getRouteDataFromURLSegments } from '../utils/routeDataUtils';

export const useCurrentProductOrSection = () => {
    const matchProduct = useMatch(ecommerceRoutes.productOrSection);

    const section1EscapedName = matchProduct?.params?.section1 || null;

    const section2EscapedName = matchProduct?.params?.section2 || null;

    const section3EscapedName = matchProduct?.params?.section3 || null;

    const productEscapedName = matchProduct?.params?.product || null;

    const routeData = getRouteDataFromURLSegments(
        section1EscapedName,
        section2EscapedName,
        section3EscapedName,
        productEscapedName,
    );

    return { routeData };
};
